import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import HomePage from './pages/home-page';
import RecrutementPage from './pages/entreprise/recrutement-page';
import RecrutementDirigeantsPage from './pages/entreprise/recrutement-dirigeants-page';
import CampagnesPage from './pages/entreprise/campagnes-page';
import ExternalisationPage from './pages/entreprise/externalisation-page';
import IAEntreprisePage from './pages/entreprise/ia-page';
import TalentHrAiPage from './pages/entreprise/TalentHrAi';
import CabinetRecrutementMarseillePage from './pages/entreprise/cabinet-recrutement-marseille';
import CabinetRecrutementMarseillePilierPage from './pages/local/cabinet-recrutement-marseille';
import CabinetRecrutementAixPage from './pages/local/cabinet-recrutement-aix-en-provence';
import CabinetRecrutementPacaPage from './pages/local/cabinet-recrutement-paca';
import CabinetRecrutementPoitiersPage from './pages/local/cabinet-recrutement-poitiers';
import OffresPage from './pages/candidat/offres-page';
import { JobsPage } from './pages/offres/JobsPage';
import PourquoiPage from './pages/candidat/pourquoi-page';
import TalentAIPage from './pages/candidat/talentai-page';
import CandidatDecouvrirPage from './pages/candidat/decouvrir-page';
import QuestionsPage from './pages/infos/questions-page';
import ChartePage from './pages/infos/charte-page';
import TarifsPage from './pages/infos/tarifs-page';
import ReservationPage from './pages/infos/reservation-page';
import ArticlesPage from './pages/ressources/articles-page';
import ArticlePage from './pages/ressources/article-page';
import EditArticlePage from './pages/admin/edit-article';
import UsersManagementPage from './pages/admin/users-management';
import OffresListAdmin from './pages/admin/offres/offres-list';
import EditOffreAdmin from './pages/admin/offres/edit-offre';
import { OffreDetailPage } from './pages/offres/offre-detail-page';
import OutilsPage from './pages/ressources/outils-page';
import RessourcesPage from './pages/ressources/ressources-page';
import MappingRHPage from './pages/ressources/mapping-rh';
import SuiviCandidaturePage from './pages/ressources/suivi-candidature';
import CalendrierRHPage from './pages/ressources/calendrier-rh';
import MentionsLegalesPage from './pages/legal/mentions-legales-page';
import ConfidentialitePage from './pages/legal/confidentialite-page';
import CGVPage from './pages/legal/cgv-page';
import TimelineRecrutementPage from './pages/private/timeline-recrutement';
import TimelineCampagnesPage from './pages/private/timeline-campagnes';
import ForecastsPage from './pages/private/forecasts';
import NotFoundPage from './pages/not-found';
import ParcoursIndexPage from './pages/parcours/parcours-index-page';
import ParcoursLandingPage from './pages/parcours/parcours-landing-page';
import ParcoursEtapePage from './pages/parcours/parcours-etape-page';
import PourquoiRecruteursIoPage from './pages/pourquoi-recruteurs-io';
import CalculateurRoiPage from './pages/ressources/calculateur-roi';
import DossierIaRecrutementPage from './pages/dossier-ia-recrutement';
import ParcoursListAdmin from './pages/admin/parcours/parcours-list';
import EditParcoursAdmin from './pages/admin/parcours/edit-parcours';
import ParcoursStepsAdmin from './pages/admin/parcours/parcours-steps';
import EditParcoursStepAdmin from './pages/admin/parcours/edit-parcours-step';
import ParcoursPreviewAdmin from './pages/admin/parcours/parcours-preview';
import CandidatsListAdmin from './pages/admin/candidats/candidats-list';
import CandidatDetailAdmin from './pages/admin/candidats/candidat-detail';
import LinkedInGeneratorPage from './pages/admin/linkedin-generator';
import SecurityDashboardPage from './pages/admin/security-dashboard';
import InsightsIndexPage from './pages/insights/insights-index';
import InsightsDetailPage from './pages/insights/insights-detail';
// Hub IA PACA — Sprint #1
import IaPacaPilierPage from './pages/ia-paca';
import AiEngineerPage from './pages/ia-paca/metiers/ai-engineer';
import MarseilleIaPage from './pages/ia-paca/marseille';
import SophiaAntipolisIaPage from './pages/ia-paca/sophia-antipolis';
// Hub IA PACA — Sprint #2
import AixEnProvenceIaPage from './pages/ia-paca/aix-en-provence';
import NiceIaPage from './pages/ia-paca/nice';
import MlEngineerPage from './pages/ia-paca/metiers/ml-engineer';
import MlopsEngineerPage from './pages/ia-paca/metiers/mlops-engineer';
import DataScientistPage from './pages/ia-paca/metiers/data-scientist';
import AiEngineersRagProductionArticle from './pages/ia-paca/articles/ai-engineers-rag-production';
// Hub IA PACA — Sprint #3 (lead magnets)
import BarometreSalairesIaPacaPage from './pages/ia-paca/barometre-salaires';
import QuizAiReadinessPage from './pages/ia-paca/quiz-ai-readiness';
// Hub IA PACA — Sprint #4 (carte interactive)
import CarteEntreprisesIaPacaPage from './pages/ia-paca/carte-entreprises';
// Hub IA PACA — Sprint #5 (8 pages métier complémentaires)
import PromptEngineerPage from './pages/ia-paca/metiers/prompt-engineer';
import AiProductManagerPage from './pages/ia-paca/metiers/ai-product-manager';
import ArchitecteIaPage from './pages/ia-paca/metiers/architecte-ia';
import DataEngineerIaPage from './pages/ia-paca/metiers/data-engineer-ia';
import ConsultantIaPage from './pages/ia-paca/metiers/consultant-ia';
import DeveloppeurLlmPage from './pages/ia-paca/metiers/developpeur-llm';
import ExpertIaGenerativePage from './pages/ia-paca/metiers/expert-ia-generative';
import AgenticAiEngineerPage from './pages/ia-paca/metiers/agentic-ai-engineer';
import AiAutomationSpecialistPage from './pages/ia-paca/metiers/ai-automation-specialist';
import { testConnection } from './lib/supabase';
import { supabase, safeSupabaseQuery } from './lib/supabase';
import { useAuth } from './AuthProvider';
import { usePageTracking } from './hooks/usePageTracking';
import toast from 'react-hot-toast';
import RequireAdmin from './components/auth/RequireAdmin';

function App() {
  const { loading: authLoading, user } = useAuth();
  const navigate = useNavigate();

  usePageTracking();

  useEffect(() => {
    testConnection().catch(err => {
      console.log('🔄 Running in offline mode');
    });
  }, []);

  useEffect(() => {
    const checkUserRole = async () => {
      if (!user) return;

      try {
        const { data: userData, error, isCorsError } = await safeSupabaseQuery(
          () => supabase
            .from('users')
            .select('role')
            .eq('id', user.id)
            .maybeSingle()
        );

        if (isCorsError || error) {
          console.warn('Error checking user role:', error);
          return;
        }

        // No automatic redirect for client role
      } catch (err) {
        console.error('Error in checkUserRole:', err);
      }
    };

    if (!authLoading) {
      checkUserRole();
    }
  }, [user, authLoading, navigate]);

  if (authLoading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-pink-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* Hub IA PACA — Sprint #1 */}
      <Route path="/ia-paca" element={<IaPacaPilierPage />} />
      <Route path="/ia-paca/metiers/ai-engineer" element={<AiEngineerPage />} />
      <Route path="/ia-paca/marseille" element={<MarseilleIaPage />} />
      <Route path="/ia-paca/sophia-antipolis" element={<SophiaAntipolisIaPage />} />
      {/* Hub IA PACA — Sprint #2 */}
      <Route path="/ia-paca/aix-en-provence" element={<AixEnProvenceIaPage />} />
      <Route path="/ia-paca/nice" element={<NiceIaPage />} />
      <Route path="/ia-paca/metiers/ml-engineer" element={<MlEngineerPage />} />
      <Route path="/ia-paca/metiers/mlops-engineer" element={<MlopsEngineerPage />} />
      <Route path="/ia-paca/metiers/data-scientist" element={<DataScientistPage />} />
      <Route
        path="/ia-paca/articles/ai-engineers-rag-production"
        element={<AiEngineersRagProductionArticle />}
      />
      {/* Hub IA PACA — Sprint #3 (lead magnets) */}
      <Route
        path="/ia-paca/barometre-salaires-ia-paca-2026"
        element={<BarometreSalairesIaPacaPage />}
      />
      <Route
        path="/ia-paca/quiz-ai-readiness"
        element={<QuizAiReadinessPage />}
      />
      {/* Hub IA PACA — Sprint #4 (carte interactive) */}
      <Route
        path="/ia-paca/carte-entreprises"
        element={<CarteEntreprisesIaPacaPage />}
      />
      {/* Hub IA PACA — Sprint #5 (8 pages métier complémentaires) */}
      <Route path="/ia-paca/metiers/prompt-engineer" element={<PromptEngineerPage />} />
      <Route path="/ia-paca/metiers/ai-product-manager" element={<AiProductManagerPage />} />
      <Route path="/ia-paca/metiers/architecte-ia" element={<ArchitecteIaPage />} />
      <Route path="/ia-paca/metiers/data-engineer-ia" element={<DataEngineerIaPage />} />
      <Route path="/ia-paca/metiers/consultant-ia" element={<ConsultantIaPage />} />
      <Route path="/ia-paca/metiers/developpeur-llm" element={<DeveloppeurLlmPage />} />
      <Route path="/ia-paca/metiers/expert-ia-generative" element={<ExpertIaGenerativePage />} />
      <Route path="/ia-paca/metiers/agentic-ai-engineer" element={<AgenticAiEngineerPage />} />
      <Route
        path="/ia-paca/metiers/ai-automation-specialist"
        element={<AiAutomationSpecialistPage />}
      />
      <Route path="/entreprise/recrutement" element={<RecrutementPage />} />
      <Route path="/entreprise/recrutement-dirigeants" element={<RecrutementDirigeantsPage />} />
      <Route path="/entreprise/campagnes" element={<CampagnesPage />} />
      <Route path="/entreprise/externalisation" element={<ExternalisationPage />} />
      <Route path="/entreprise/ia" element={<IAEntreprisePage />} />
      <Route path="/entreprise/talent-rh-ai" element={<TalentHrAiPage />} />
      <Route path="/cabinet-recrutement-marseille" element={<CabinetRecrutementMarseillePilierPage />} />
      <Route path="/cabinet-recrutement-aix-en-provence" element={<CabinetRecrutementAixPage />} />
      <Route path="/cabinet-recrutement-paca" element={<CabinetRecrutementPacaPage />} />
      <Route path="/cabinet-recrutement-poitiers" element={<CabinetRecrutementPoitiersPage />} />
      <Route path="/entreprise/cabinet-recrutement-marseille" element={<CabinetRecrutementMarseillePage />} />
      <Route path="/candidat/offres" element={<OffresPage />} />
      <Route path="/offres" element={<JobsPage />} />
      <Route path="/offres/:slug" element={<OffreDetailPage />} />
      <Route path="/candidat/pourquoi" element={<PourquoiPage />} />
      <Route path="/candidat/talentai" element={<TalentAIPage />} />
      <Route path="/candidat/decouvrir" element={<CandidatDecouvrirPage />} />
      <Route path="/infos/questions" element={<QuestionsPage />} />
      <Route path="/infos/charte" element={<ChartePage />} />
      <Route path="/infos/tarifs" element={<TarifsPage />} />
      {/* /infos/contact → /reservation : la page Contact historique a été
          remplacée par le formulaire de réservation /reservation (cf. PR fix
          contact-redirect-to-reservation). Redirect côté React Router en
          fallback ; côté Netlify, un 301 dans netlify.toml capture aussi
          les requêtes directes / SEO. */}
      <Route
        path="/infos/contact"
        element={<Navigate to="/reservation" replace />}
      />
      <Route path="/reservation" element={<ReservationPage />} />
      <Route path="/ressources/articles" element={<ArticlesPage />} />
      <Route path="/ressources/articles/new/edit" element={<EditArticlePage />} />
      <Route path="/ressources/articles/:slug" element={<ArticlePage />} />
      <Route path="/ressources/articles/:slug/edit" element={<EditArticlePage />} />
      <Route path="/ressources/outils" element={<OutilsPage />} />
      <Route path="/ressources/outils/suivi-candidature" element={<SuiviCandidaturePage />} />
      <Route path="/ressources/outils/calendrier-rh" element={<CalendrierRHPage />} />
      <Route path="/ressources/ressources" element={<RessourcesPage />} />
      <Route path="/ressources/mapping-rh" element={<MappingRHPage />} />
      <Route path="/legal/mentions-legales" element={<MentionsLegalesPage />} />
      <Route path="/legal/confidentialite" element={<ConfidentialitePage />} />
      <Route path="/legal/cgv" element={<CGVPage />} />
      {/* Admin routes — all require admin role (server-side verified via RequireAdmin) */}
      <Route path="/admin/users" element={<RequireAdmin><UsersManagementPage /></RequireAdmin>} />
      <Route path="/admin/offres" element={<RequireAdmin><OffresListAdmin /></RequireAdmin>} />
      <Route path="/admin/offres/new" element={<RequireAdmin><EditOffreAdmin /></RequireAdmin>} />
      <Route path="/admin/offres/:id/edit" element={<RequireAdmin><EditOffreAdmin /></RequireAdmin>} />
      <Route path="/admin/timeline-recrutement" element={<RequireAdmin><TimelineRecrutementPage /></RequireAdmin>} />
      <Route path="/admin/timeline-campagnes" element={<RequireAdmin><TimelineCampagnesPage /></RequireAdmin>} />
      <Route path="/admin/forecasts" element={<RequireAdmin><ForecastsPage /></RequireAdmin>} />
      <Route path="/admin/parcours" element={<RequireAdmin><ParcoursListAdmin /></RequireAdmin>} />
      <Route path="/admin/parcours/new" element={<RequireAdmin><EditParcoursAdmin /></RequireAdmin>} />
      <Route path="/admin/parcours/:id/edit" element={<RequireAdmin><EditParcoursAdmin /></RequireAdmin>} />
      <Route path="/admin/parcours/:id/steps" element={<RequireAdmin><ParcoursStepsAdmin /></RequireAdmin>} />
      <Route path="/admin/parcours/:id/steps/:stepId/edit" element={<RequireAdmin><EditParcoursStepAdmin /></RequireAdmin>} />
      <Route path="/admin/parcours/:id/preview" element={<RequireAdmin><ParcoursPreviewAdmin /></RequireAdmin>} />
      <Route path="/admin/candidats" element={<RequireAdmin><CandidatsListAdmin /></RequireAdmin>} />
      <Route path="/admin/candidats/:userId" element={<RequireAdmin><CandidatDetailAdmin /></RequireAdmin>} />
      <Route path="/admin/linkedin-generator" element={<RequireAdmin><LinkedInGeneratorPage /></RequireAdmin>} />
      <Route path="/admin/security" element={<RequireAdmin><SecurityDashboardPage /></RequireAdmin>} />
      <Route path="/insights" element={<InsightsIndexPage />} />
      <Route path="/insights/:slug" element={<InsightsDetailPage />} />
      <Route path="/decouvrir" element={<ParcoursIndexPage />} />
      <Route path="/pourquoi-recruteurs-io" element={<PourquoiRecruteursIoPage />} />
      <Route path="/ressources/calculateur-roi" element={<CalculateurRoiPage />} />
      <Route path="/dossier-ia-recrutement" element={<DossierIaRecrutementPage />} />
      <Route path="/decouvrir/:companySlug" element={<ParcoursLandingPage />} />
      <Route path="/decouvrir/:companySlug/etape/:stepId" element={<ParcoursEtapePage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;